
























































import { Component, Vue } from "vue-property-decorator";
import GlobalMixins from "@/global.mixin";

import {importExportApi} from "../../../services/api/importexport.api";
import LoadingPopup from "@/components/LoadingPopup.vue";
@Component({
  mixins: [GlobalMixins],
  components: { LoadingPopup }
})
export default class ImportExportView extends Vue {

  loading = false;
  currentFile = undefined;
  fileSelected = [];

  fileName = "";
  fileObject = null;
  url = "";

  dialog = false;
  dialogTitle =  "";
  dialogText = "";
  $refs: any;

  selectFile(event) {

    const file = event.target.files[0];
    // console.log("file: ", file);

    if (!file) {
      return;
    }
    this.loading = true;

    importExportApi.import(file)
    .then( res => {
      // console.log("res:", res.data);
      if (res.data.status === 1) {
        // success
        this.dialogTitle = "Sikeres betöltés!";
        this.dialogText = res.data.msg;
      } else if (res.data.status === 2 ) {
        this.dialogTitle = "Existing items!";
        const existingItems = res.data.docs.map( el => el).join(", ");
        this.dialogText = "Eszközök : " + existingItems;
      } else if (res.data.status === 3) {
        // validation errors
        this.dialogTitle = "Hiba van az adatokban!";
        this.dialogText = res.data.errors.join("<br>");
      } else {
        this.dialogTitle = "Error";
        this.dialogText = res.data.msg;
      }
      this.dialog = true;
      this.loading = false;

      // Clear the file input so the same file can be selected again
      event.target.value = "";
      this.fileName = "";
    })
    .catch( err => {

      this.dialogTitle = "Unexpected Response!!";
      this.dialogText = JSON.stringify(err);

      this.dialog = true;
      this.loading = false;

      // Clear the file input so the same file can be selected again
      event.target.value = "";
      this.fileName = "";
    });
  }

  download() {
    importExportApi.downloadEmptyExcel(0, "sample.xlsx");
  }

  onPickFile() {
      this.$refs.fileInput.click();
  }
}
